module.exports = __webpack_public_path__ + "img/web3.c32580ec.png";